<template>
  <v-card v-if="show" width="100%" min-height="150" v-intersect="onIntersect" outlined :href="getUrl"
          class="testimonials-card d-flex align-center justify-center flex-column">
    <v-card-text class="text-center">
      <v-icon size="64">{{ testimonials.icon }}</v-icon>
    </v-card-text>
    <v-card-title class="text-center justify-center break-word primary--text" style="direction: ltr;font-size: 2.5em">
      {{ testimonials.type === 'percent' ? '%' : '+' }}{{ animatedNumber }}
    </v-card-title>
    <v-card-text class="text-center" style="font-size: 1.1em" v-text="testimonials.name"/>
  </v-card>
</template>

<script>
export default {
  name: "testimonialsCard",

  props: {
    testimonials: Object
  },

  data: () => ({
    number: 0,
    tweenedNumber: 0,
    isIntersecting: false,
    show: false
  }),

  computed: {
    animatedNumber: function () {
      return this.tweenedNumber.toFixed(0);
    },
    getUrl() {
      let link = this.testimonials.link
      if (link && link.length > 0)
        if (!link.startsWith('http')) {
          link = 'https://' + link
        }

      return link
    }
  },

  created() {
    setTimeout(() => {
      this.show = true
    }, 1000)
  },

  watch: {
    testimonials: {
      deep: true,

      handler(val) {
        if (this.isIntersecting) {
          this.number = parseInt(val.counter)
        }
      }
    },
    number: function (newValue) {
      window.gsap.to(this.$data, {duration: 2, tweenedNumber: newValue, delay: .5});
    },
    isIntersecting: function (val) {
      if (val)
        this.number = parseInt(this.testimonials.counter)
    }
  },

  methods: {
    onIntersect(entries, observer) {
      // More information about these options
      // is located here: https://developer.mozilla.org/en-US/docs/Web/API/Intersection_Observer_API
      this.isIntersecting = entries[0].isIntersecting
    },
  }
}
</script>

<style scoped>
.testimonials-card {
  box-shadow: none !important;
  border-radius: 12px !important;
  transition: .25s ease-in;
}

.testimonials-card:hover {
  box-shadow: 0 3px 20px 0 rgba(0, 0, 0, .05), 0 5px 10px 1px rgba(0, 0, 0, .1) !important;
  background-color: #fff !important;
  transform: translateY(-10px);
}
</style>